

































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { doc } from '../doc'
import * as utils from "../utils";
import * as utils_auth from "../utils_auth";
import { RawLocation } from "vue-router";
import DocGridComponent from '@/components/DocGridComponent.vue'; // @ is an alias to /src
import { DocsendUser } from '../DocsendUser';
import { IPaginationResult } from '@/PaginationResult'

@Component({
  name: 'docs',
  components: { DocGridComponent }
})
export default class Docs extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public docs: doc[] = [];
  public search: string = ''
  public sort: string = 'recentFirst'
  public sortOptions: any[] = [
    // { text: 'Default sort', value: 'default' },
    // { text: '-------------', disabled: true },
    { text: 'Recent first', value: 'recentFirst' },
    { text: 'Keyword score', value: 'textScore' },
    { text: 'Most similiar', value: 'mostSimilar' }
  ]
  public paginationResult: IPaginationResult = null
  public moreLikeThis: string = null

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): DocsendUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }
  public async onTextSubmit(): Promise<void> {
    this.pageNumberToLoadNext = 1
    this.search = utils.replaceBooleanWords(this.search)
    if (this.search && this.search.trim().length > 0) this.sort = 'textScore'   // makes more sense
    else this.sort = 'recentFirst'
    await this.fetchData()
  }
  public editedDoc(index: number, d: doc): void {
    if (this.$store.state.devmode) console.log(`Child component reports that index ${index} was edited (${d.title})`)
    Vue.set(this.docs, index, d)      // just like this.docs[index] = d but this triggers reactivity; TODO: https://stackoverflow.com/questions/42807888/vuejs-and-vue-set-update-array
  }

  public async clickedMoreLikeThis(id: string) {
    this.search = ''
    this.sort = 'mostSimilar'
    if (this.moreLikeThis) this.moreLikeThis += ', ' + id; else this.moreLikeThis = id
    this.pageNumberToLoadNext = 1
    await this.fetchData()
  }

  public async infiniteHandler(state: any): Promise<void> {
    const numReturned: number = await this.fetchData(true)
    if (numReturned === 0) {
      console.log(`infiniteHandler(): state.complete after getting 0 items`)
      state.complete()
    } else {
      state.loaded();
    }
  }
  // private, non-reactive member variables
  private url: string = utils.getURLprefix() + "/api/docs";
  private pageNumberToLoadNext: number = 1
  private lastFetchSucceeded: boolean;
  private perPage: number = 18

  // private functions not available directly to HTML template
  private async mounted(): Promise<void> {
    if (this.$store.state.devmode) console.log("docsComponent mounted()")
    await this.fetchData()
  }

  @Watch('sort')
  private async onSortChanged(val: string, oldVal: string) {
    this.pageNumberToLoadNext = 1
    await this.fetchData()
  }

  private async fetchData(calledByInfiniteHandlerOrTimer?: boolean): Promise<number> {
    if (!this.isAuthenticated) return
    let url: string = `${this.url}/?perPage=${this.perPage}&page=${this.pageNumberToLoadNext}&search=${encodeURIComponent(this.search)}&sort=${this.sort}`;
    if (this.moreLikeThis) url += `&moreLikeThis=${this.moreLikeThis}`

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (url === this.lastFetchedURL) {
        console.log(`Docs.fetchData() aborting because already loading ${url}`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return -1
      }
      if (calledByInfiniteHandlerOrTimer) {
        console.log(`Docs.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return -1
      }
      console.log(`Docs.fetchData() delaying ${url} by 1s`)
      await utils.sleep(1000)       // wait 1 s to prevent race condition
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;
    try {
      // console.log(url)
      this.lastFetchSucceeded = false;
      const response: any = await utils.makeGetCall(url);

      // in case old version
      if (utils.isClientOld()) {
        console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // check for auth failure
      const error: string = response.data.error
      if (error && error.includes('auth failure')) {
        this.$store.commit("setLoading", { loading: false });
        utils_auth.logout()
        return
      }

      if (error) {
        utils.toast(this, 'Error', error)
        this.$store.commit("setLoading", { loading: false });
        return
      }

      // might as well update our user cache
      if (response.data.user) {
        const me: DocsendUser = new DocsendUser(response.data.user)
        me.updateMeToStoreAndLocalStorage()
      }

      // pagination result
      this.paginationResult = response.data.paginationResult

      // load up the docs
      let newRawItems: doc[] = response.data.docs
      if (newRawItems) {
        newRawItems = newRawItems.map((po) => new doc(po));
        if (this.pageNumberToLoadNext === 1) {
          console.log(`Replacing this.docs (was ${this.docs.length} long) with array of ${newRawItems.length} items`)
          this.docs = newRawItems;
        } else {
          console.log(`Concating this.docs (was ${this.docs.length} long) with array of ${newRawItems.length} items`)
          this.docs = this.docs.concat(newRawItems)
          console.log(`After concatenation, this.docs is ${this.docs.length} long`)
        }

        if (this.$store.state.devmode) console.log(`fetchData() resulted in ${this.docs.length} docs in this.docs`)

        this.pageNumberToLoadNext++
        this.lastFetchSucceeded = true
        this.$store.commit('setLoading', { loading: false });

        return newRawItems.length
      } else {
        this.lastFetchSucceeded = false;
        this.$store.commit('setLoading', { loading: false });

        return 0
      }

  } catch (error) {
      utils.toast(this, 'Error', 'Could not load docs')
      if (this.$store.state.devmode) console.error(error);
    }
    this.$store.commit("setLoading", { loading: false });
  }
}
